import React from 'react';
import InfoSection from '../Steps/InfoSection';
import OnBoardField from '../Steps/OnBoardField';
import BackButton from '../Pagination/BackButton';
import DarkModeBtn from '../../../../common/TopBar/Buttons/DarkModeBtn';
import { StepsProp } from './SteppersData';
import { useDarkModeStore } from '../../../../store/useDarkModeStore';

interface StepperContentProps {
    activeStep: number;
    filteredSteps: StepsProp<any>[];
    goToNextStep: () => void;
    goToPreviousStep: () => void;
}

const StepperContent = ({ activeStep, filteredSteps, goToPreviousStep, goToNextStep }: StepperContentProps) => {
    const { darkMode } = useDarkModeStore();

    const handleSteps = () => {
        const list = filteredSteps[activeStep].list;
        const fieldName = filteredSteps[activeStep].fieldName;
        const form = filteredSteps[activeStep].form ?? undefined;
        const isInfoSection = filteredSteps[activeStep].isInfoSection ?? false;

        if (!fieldName) return null;

        if (isInfoSection) {
            return <InfoSection
                fieldName={fieldName}
                activeStep={activeStep}
                filteredSteps={filteredSteps}
                goToNextStep={goToNextStep}
            />;
        }
        return <OnBoardField
            form={form}
            list={list ?? ''}
            fieldName={fieldName}
            activeStep={activeStep}
            filteredSteps={filteredSteps}
            goToNextStep={goToNextStep}
        />
    }

    return <div className='d-flex flex-column gap-5' style={{ padding: '.5% 5% 2% 8%', minHeight: '100vh' }}>
        <div className='d-flex flex-row'>
            {activeStep !== 0 && <BackButton activeStep={activeStep} goToPreviousStep={goToPreviousStep} />}
            <span className='ms-auto'><DarkModeBtn styleClass={darkMode ? 'text-white' : 'text-primary'} /></span>
        </div>
        {handleSteps()}
    </div>
};

export default StepperContent;
